import { render, staticRenderFns } from "./BaseTeacherModal__Style#Drawer.vue?vue&type=template&id=a728351e&scoped=true"
import script from "./BaseTeacherModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./BaseTeacherModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./BaseTeacherModal__Style#Drawer.vue?vue&type=style&index=0&id=a728351e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a728351e",
  null
  
)

export default component.exports